import store from '@/store'

export function getFilteredHistory (briefing) {
  const fieldList = [...arguments].slice(1)
  return briefing.flightHistory.filter(item => fieldList.includes(item.field)) || []
}

export function checkChanges (briefing, string) {
  const timeFrame = briefing.std.slice(0, 7)
  const existingHistory = store.getters.historyByTimeFrame(timeFrame)
  const idLastUpdates = briefing[string][0]?.id
  if (briefing[string][0]?.silent && !existingHistory?.includes(idLastUpdates)) {
    store.commit('addItemsToReadingHistory', { timeFrame, listOfId: [idLastUpdates] })
    return false
  }
  return idLastUpdates ? !existingHistory?.includes(idLastUpdates) : false
}

const HISTORY_FIELDS = ['historyRoute', 'historyTailNumber', 'historyFlightNumber', 'historyEtd', 'historyCrew']

export function markAllFlightChangesRead (briefing) {
  const timeFrame = briefing.std.slice(0, 7)
  const existingHistory = store.getters.historyByTimeFrame(timeFrame)
  const historyIds = HISTORY_FIELDS.map(field => briefing[field][0]?.id)
      .filter(id => id && !existingHistory?.includes(id))
  if (historyIds.length > 0) {
    store.commit('addItemsToReadingHistory', { timeFrame, listOfId: historyIds })
  }
}
